import { render } from "./AdvantagesApp.vue?vue&type=template&id=6b7b8d5e"
import script from "./AdvantagesApp.vue?vue&type=script&lang=js"
export * from "./AdvantagesApp.vue?vue&type=script&lang=js"

import "./AdvantagesApp.vue?vue&type=style&index=0&id=6b7b8d5e&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__